
var exports = {
    configObj: {},
  errors: function(minAge) {
    var plural = (parseInt(minAge) === 1) ? '' : 's'
        return {
            invalidDate: 'La fecha introducida no es correcta',
            minAgeOverflow: 'El titular tiene que ser mayor de ' + minAge + ' año' + plural,
            maxAgeOverflow: 'El asegurado no puede ser mayor de 100 años',
            todayOverflow: 'Para continuar, introduce una fecha válida',
        }
    },

  /**
   * config
   * - returns config obj (Its a function because we need to calculate the max and min dates)
   * @return { object } config obj
   */
  config: function(minYears, maxYears) {
    minYears = (minYears) ? minYears : 100 //default
    return {
      inputFormat: 'dd/mm/yyyy',
      placeholder: 'dd/mm/aaaa',
      min: this.date(minYears),
      max: this.date(maxYears),
      insertMode: true,
      onKeyValidation: function (a, isValid) {
        var isCompleted = !isNaN(this.value.replace(/\//g, ''))
          var add_remove = (isCompleted || isValid) ? 'remove' : 'add'
        if (add_remove == 'remove') {
          if (this.getAttribute('id') == "txtDateInput") {
            //document.getElementById("error-date1").innerHTML = "";
          }
          else if (String(this.getAttribute('id')).includes("txtCalendarBirthDate")) {
            $('#errorContainer').addClass('hidden');
          }
        }
        //else {
        //  console.log(this.getAttribute('id'))
        //  if (this.getAttribute('id') == "txtDateInput") {
        //    document.getElementById("error-date1").innerHTML = "Por favor, introduce una fecha correcta";
        //  }
        //  else if (String(this.getAttribute('id')).includes("txtDate")) {
        //    var errorId = String(this.getAttribute('id')).replace("txtDate", "Additional");
        //    document.getElementById(errorId).innerHTML = "Por favor, introduce una fecha correcta";
        //  }
        //}
          this.classList[add_remove]('error')
      },
    }
  },

  /**
   * date
   * - return dates for config with format dd/mm/yyyy
   * - if the argument years is passed returns date n years previous to now
   * @param {number} years
   * @return { string } date string
   */
  date: function(years) {
    var d = new Date()
    years = (years && !isNaN(years)) ? parseInt(years) : 0
    return [
             d.getDate(), // d | dd
            (d.getMonth() + 1), // m | mm
             d.getFullYear() - years // yyyy
           ].map(function(inp){
              if(inp < 10){
                inp = '0' + inp
              }
              return inp
            }).join('/')
  },

  /**
   * prefillYear
   * - custom auto prefill of years on first input of year section
   * @param { HTMLElement } input - this input
   * @param { KeyboardEvent } ev - event obj
   * @param { object } dateArray
   * @param { boolean } monthCompleted
   */
  prefillYear: function(input, ev, dateArray, monthCompleted) {
    if(monthCompleted && dateArray[2] === '') {
      switch(ev.key) {
        case '0': 
          dateArray[2] = '20';
          break;
        case '1':
        case '2':
           //doesnt autoprefill
          break;
        default:
          dateArray[2] = '19';
      }
      dateArray[2] = (dateArray[2] + 'aaaa').substring(0,4);
      input.value = dateArray.join('/')
    }
    },


/**
 * setErrors for Additional insureres
 * - sets message error text in html element for error
 * - 3 types of error: invalid date, min date overflow, max date overflow
 * @param { HTMLElement } input - this input
 * @param { KeyboardEvent } ev - event obj
 * @param { object } dateArray
 * @param { boolean } monthCompleted
 */

    setErrorsAdditionalInsurer: function (input, ev, dateArray, monthCompleted) {
        var minAge = input.inputmask.userOptions.minAge,
            errors = this.errors(minAge),
            error = "" // generic error
        if (monthCompleted) {
            var datemax = this.getDateCompare(dateArray, ev.key, '0'),
                datemin = this.getDateCompare(dateArray, ev.key, '9'),
                min = input.inputmask.opts.min.date,
                max = input.inputmask.opts.max.date
            switch (true) {
                case datemax > max:
                    error = errors.todayOverflow
                    $('#errorContainer').removeClass('hidden');
                    $('#errorContainer').text(error);
                    break;
                case datemin < min:
                    error = errors.todayOverflow
                    $('#errorContainer').removeClass('hidden');
                    $('#errorContainer').text(error);
                    break;
            }
            if (error.length == 0) {
                $('#errorContainer').addClass('hidden');
                $('#errorContainer').text(error);
            }
        }
        //adds text to .error-txt if exists
        var parent = this.getParent(input, 'form-control')
        if (parent) {
          
        }
    },

  /**
   * setErrors
   * - sets message error text in html element for error
   * - 3 types of error: invalid date, min date overflow, max date overflow
   * @param { HTMLElement } input - this input
   * @param { KeyboardEvent } ev - event obj
   * @param { object } dateArray
   * @param { boolean } monthCompleted
   */
    setErrors: function (input, ev, dateArray, monthCompleted) {
    var minAge = input.inputmask.userOptions.minAge,
        errors = this.errors(minAge),
            error = "" // generic error
        //$('#dobWarning').addClass('hidden');
        if (monthCompleted) {
      var min     = input.inputmask.opts.min.date,
            max = input.inputmask.opts.max.date
          if (input.id == "txtDateInput") {
              if (dateMax > max || dateMin < min){
              document.getElementById('error-date1').innerHTML = errors.todayOverflow;
            }
          
          }
          else {
            var errorId = input.id.replace("txtDate", "Additional");
            if (dateMax > max || dateMin < min){
              document.getElementById(errorId).innerHTML = errors.todayOverflow;
            }
          }
      
        }

    //adds text to .error-txt if exists
    var parent = this.getParent(input, 'form-control')
        if (parent) {
        
      //var errortxt = parent.querySelector('.error-txt')
      //if(errortxt) {
      //  errortxt.innerHTML = error
      //}
    }
  },

  /**
  * aux functions
  */

  getParent: function(input, selector) {
    var parent = input
    while(parent.parentNode && !parent.classList.contains(selector)) {
      parent = parent.parentNode
    }
    return parent
  },

  isMonthCompleted: function(dateArray) {
    return dateArray[1] && dateArray[1].length === 2
  },

  getDateArray: function(input) {
    return input.value.replace(/[a-z]/g, '').split('/')
  },

    getDateCompare: function (date, inp, pad) { 
        date[2] = (date[2].replace(/a/g, '') + inp + Array(4).fill(pad).join('')).substring(0, 4) 
    return new Date(date[2],date[1]-1,date[0])
  },

}

function maskingDob() {
            dateMaskInputs = document.querySelectorAll('[date-mask]')
        //applies input mask for every HTML element with the attr 'date-mask'
    for (var i = 0; i < dateMaskInputs.length; i++) {
            var dateMaskInput = dateMaskInputs[i],
                minYears = dateMaskInput.getAttribute('max-age'),
                maxYears = dateMaskInput.getAttribute('min-age'),
                config = exports.configObj = exports.config(minYears, maxYears),
                imask = new Inputmask('datetime', config),
                ignorableKeys = imask.opts.ignorables

            imask.userOptions.minAge = maxYears
            imask.mask(dateMaskInput);

            //error functionality on keydown
            dateMaskInput.addEventListener('keypress', function (ev) {
                var input = this
                if (ignorableKeys.indexOf(ev.keyCode) < 0) {
                    var dateArray = exports.getDateArray(input),
                        monthCompleted = exports.isMonthCompleted(dateArray)
                    //exports.prefillYear(input, ev, dateArray, monthCompleted)
                        exports.setErrors(input, ev, dateArray, monthCompleted)
                } else if (ev.keyCode === 8) { // backspace
                    input.classList.remove('error')
                }
            })
        }
    
}

